import { createSlice } from "@reduxjs/toolkit";
const initialRemindersFilter = {
    DateFrom: undefined,
    DateTo: undefined,
    Campaigns: [],
    ReminderIds: '',
    Name: '',
    Type: '', 
    Description: '',
    Donors: [],
    Status: -1}
 
const initialState = {
    paymentsFilter: {}, // Regular payments filter
    paymentsFilterObject: null, // Regular payments API filter object
    paymentsHasFilter: false,
    schoolPaymentsFilter: {}, // School payments filter (separate from regular)
    schoolPaymentsFilterObject: null, // School payments API filter object
    schoolPaymentsHasFilter: false,
    // Pledges filters - separate for regular and school
    pledgesFilter: {}, // Regular pledges filter
    pledgesFilterString: '',
    pledgesHasFilter: false,
    schoolPledgesFilter: {}, // School pledges filter (separate from regular)
    schoolPledgesFilterString: '',
    schoolPledgesHasFilter: false,
    // Recurring payments filters - separate for regular and school
    recPaymentsFilter: {}, // Regular recurring payments filter
    recPaymentsFilterString: '',
    recPaymentsHasFilter: false,
    schoolRecPaymentsFilter: {}, // School recurring payments filter (separate from regular)
    schoolRecPaymentsFilterString: '',
    schoolRecPaymentsHasFilter: false,
    // Recurring pledges filters - separate for regular and school
    recPledgesFilter: {}, // Regular recurring pledges filter
    recPledgesFilterString: '',
    recPledgesHasFilter: false,
    schoolRecPledgesFilter: {}, // School recurring pledges filter (separate from regular)
    schoolRecPledgesFilterString: '',
    schoolRecPledgesHasFilter: false,
    donorsFilter: {},
    donorsFilterString: '',
    donorHasFilter: false,
    donorsSearch: '',
    donorsReloadToken: 0,
    remindersFilter: initialRemindersFilter,
    remindersFilterString: '',
    reminderHasFilter: false,
    parentsFilter: {},
    parentsFilterString: '',
    parentHasFilter: false,
    studentsFilter: {},
    studentsFilterString: '',
    studentHasFilter: false
}
const filtersSlice = createSlice({
    name: "filters",
    initialState,
    reducers: {
        setPaymentsFilter(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolPaymentsFilter = action.payload.filter
                state.schoolPaymentsHasFilter = true
            } else {
                state.paymentsFilter = action.payload.filter
                state.paymentsHasFilter = true
            }
        },
        setPaymentsFilterObject(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolPaymentsFilterObject = action.payload.filterObject
            } else {
                state.paymentsFilterObject = action.payload.filterObject
            }
        },
        resetPaymentsFilter(state, action) {
            const isSchool = action.payload?.isSchool === true
            if (isSchool) {
                state.schoolPaymentsFilter = {}
                state.schoolPaymentsFilterObject = null
                state.schoolPaymentsHasFilter = false
            } else {
                state.paymentsFilter = {}
                state.paymentsFilterObject = null
                state.paymentsHasFilter = false
            }
        },
        setPledgesFilter(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolPledgesFilter = action.payload.filter
                state.schoolPledgesHasFilter = true
            } else {
                state.pledgesFilter = action.payload.filter
                state.pledgesHasFilter = true
            }
        },
        setPledgesFilterString(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolPledgesFilterString = action.payload.filter
            } else {
                state.pledgesFilterString = action.payload.filter
            }
        },
        resetPledgesFilter(state, action) {
            const isSchool = action.payload?.isSchool === true
            if (isSchool) {
                state.schoolPledgesFilter = {}
                state.schoolPledgesFilterString = ''
                state.schoolPledgesHasFilter = false
            } else {
                state.pledgesFilter = {}
                state.pledgesFilterString = ''
                state.pledgesHasFilter = false
            }
        },
        setDonorsFilter(state, action){
            state.donorsFilter = action.payload
            state.donorHasFilter = true
        },
        setDonorsSearch(state, action){
            state.donorsSearch = action.payload || ''
        },
        requestDonorsListReload(state) {
            state.donorsReloadToken += 1
        },
        setDonorsFilterString(state, action){
            state.donorsFilterString = action.payload
        },
        resetDonorsFilter(state){
            state.donorsFilter = {}
            state.donorHasFilter = false
            state.donorsFilterString = ''
        },
        setRecPaymentsFilter(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolRecPaymentsFilter = action.payload.filter
                state.schoolRecPaymentsHasFilter = true
            } else {
                state.recPaymentsFilter = action.payload.filter
                state.recPaymentsHasFilter = true
            }
        },
        setRecPaymentsFilterString(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolRecPaymentsFilterString = action.payload
            } else {
                state.recPaymentsFilterString = action.payload
            }
        },
        resetRecPaymentsFilter(state, action) {
            const isSchool = action.payload?.isSchool === true
            if (isSchool) {
                state.schoolRecPaymentsFilter = {}
                state.schoolRecPaymentsFilterString = ''
                state.schoolRecPaymentsHasFilter = false
            } else {
                state.recPaymentsFilter = {}
                state.recPaymentsFilterString = ''
                state.recPaymentsHasFilter = false
            }
        },
        setRecPledgesFilter(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolRecPledgesFilter = action.payload.filter
                state.schoolRecPledgesHasFilter = true
            } else {
                state.recPledgesFilter = action.payload.filter
                state.recPledgesHasFilter = true
            }
        },
        setRecPledgesFilterString(state, action) {
            const isSchool = action.payload.isSchool === true
            if (isSchool) {
                state.schoolRecPledgesFilterString = action.payload
            } else {
                state.recPledgesFilterString = action.payload
            }
        },
        resetRecPledgesFilter(state, action) {
            const isSchool = action.payload?.isSchool === true
            if (isSchool) {
                state.schoolRecPledgesFilter = {}
                state.schoolRecPledgesFilterString = ''
                state.schoolRecPledgesHasFilter = false
            } else {
                state.recPledgesFilter = {}
                state.recPledgesFilterString = ''
                state.recPledgesHasFilter = false
            }
        },
        setRemindersFilter(state, action) {
            state.remindersFilter = action.payload;
            state.reminderHasFilter = true
        },
        setRemindersFilterString(state, action) {
            state.remindersFilterString = action.payload
        },
        resetRemindersFilter(state) {
            state.remindersFilter = initialRemindersFilter
            state.remindersFilterString = ''
            state.reminderHasFilter = false
        },
        setParentsFilter(state, action) {
            state.parentsFilter = action.payload;
            state.parentHasFilter = true
        },
        setParentsFilterString(state, action) {
            state.parentsFilterString = action.payload
        },
        setStudentsFilter(state, action) {
            state.studentsFilter = action.payload;
            state.studentHasFilter = true
        },
        setStudentsFilterString(state, action) {
            state.studentsFilterString = action.payload
        },
        resetParentsFilter(state) {
            state.parentsFilter = {}
            state.parentsFilterString = ''
            state.parentHasFilter = false
        },
        resetStudentsFilter(state) {
            state.studentsFilter = {}
            state.studentsFilterString = ''
            state.studentHasFilter = false
        },
        resetState:() => initialState,
    },
});

export const filtersActions = filtersSlice.actions;

export default filtersSlice;
